/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { type JSX } from 'react'

export type FixRequestLinkProps = JSX.IntrinsicElements['a']

export const FixRequestLink = ({
  children,
  href = 'https://forms.gle/bddRXrzgb6djuZkK7',
  ...props
}: FixRequestLinkProps) => {
  return (
    <a
      {...props}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      css={fixRequestStyle}
    >
      <span>{children}</span>
    </a>
  )
}

const fixRequestStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  color: #3f3d35;
  font-size: 12px;
  line-height: 130%;
  background-color: #edeceb;
  width: 100%;
  border-radius: 30px;
`
